import MaskedInput from "react-text-mask";
import React, {
  forwardRef,
  memo,
  useCallback,
  useImperativeHandle,
  useState,
} from "react";
import IMaskedPhoneInput from "./types";
import { formatPhoneValue, phoneMask } from "./constants";
import { Box, FormHelperText } from "@mui/material";
import styles from "./MaskedPhoneInput.styled";

const MaskedPhoneInput = forwardRef<HTMLInputElement, IMaskedPhoneInput>(
  ({ formik, placeholder, id, name, onBlur, error, errorText }, ref) => {
    const maskedInputRef = React.useRef<MaskedInput>(null);
    const [formattedValue, setFormattedValue] = useState<string>(
      formatPhoneValue(formik.values[name] || ""),
    );

    useImperativeHandle(
      ref,
      () => maskedInputRef.current?.inputElement as HTMLInputElement,
    );

    const handlePhoneChange = useCallback(
      (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        const numericValue = value.replace(/\D/g, "");
        setFormattedValue(formatPhoneValue(numericValue));
        formik.setFieldValue(name, numericValue);
      },
      [formik, name],
    );

    const handlePhoneBlur = useCallback(
      (event: React.ChangeEvent<HTMLInputElement>) => {
        onBlur && onBlur();
        formik.handleBlur(event);
      },
      [formik, onBlur],
    );

    return (
      <Box sx={styles.inputWrap(error)}>
        <MaskedInput
          id={id}
          mask={phoneMask}
          placeholder={placeholder}
          onChange={handlePhoneChange}
          onBlur={handlePhoneBlur}
          ref={maskedInputRef}
          value={formattedValue}
        />
        {error && (
          <FormHelperText sx={styles.errorText}>{errorText}</FormHelperText>
        )}
      </Box>
    );
  },
);

export default memo(MaskedPhoneInput);
